// extracted by mini-css-extract-plugin
module.exports = {"root":"DetailBox_root__3QK6R","icon":"DetailBox_icon__cd7rQ","body":"DetailBox_body__3pBEf"};